import { openLinkInNewTab } from '../../../utils/openLinkInNewTab';
import { downloadMediasFrame } from './downloadMediasFrame';

export const downloadReadyMediasZip = (url: string) => {
  const hasClickActivation = navigator.userActivation?.isActive ?? false;
  if (hasClickActivation) {
    openLinkInNewTab(url);
    return;
  }

  downloadMediasFrame(url);
};
